var CheckoutState = /* @__PURE__ */ ((CheckoutState2) => {
  CheckoutState2["InProgress"] = "InProgress";
  CheckoutState2["ReadyToOrder"] = "ReadyToOrder";
  CheckoutState2["Finalized"] = "Finalized";
  return CheckoutState2;
})(CheckoutState || {});
export {
  CheckoutState
};
//# sourceMappingURL=checkoutState.js.map
